/** Plan resource limits: `null` = unlimited, `0` = not included. */

/** Missing or malformed values fail closed as 0; only an explicit null is unlimited. */
export function normalizePlanLimit(value: unknown): number | null {
  if (value === null) return null
  return typeof value === 'number' ? value : 0
}

export function fitsPlanLimit(count: number, limit: number | null): boolean {
  return limit === null || count <= limit
}

export function planLimitIncludes(limit: number | null): boolean {
  return limit !== 0
}
